import { validateScoreRules } from '../services/Scores';
import { IAlertRule, IScoreRule } from '../interfaces/Score';
import { AlertRuleDispatch, ScoreRuleDispatch } from '../interfaces/Reducers';
export interface IRuleError {
    id: IScoreRule['id'],
    error: string | undefined
}

export interface IAlertError {
    id: IScoreRule['id'],
    error: string | undefined
}

interface StateScore {
    scoreRules: IScoreRule[]
    scoreErrors: IRuleError[]
    deletedIDs: number[]
}

export const scoreRulesReducer = (state: StateScore, action: ScoreRuleDispatch) => {
    if (action.type === 'ADD_RULE') {
        const newRule: IScoreRule = { color_alert: '#009e03', value: 0, comparison: '<=', id: crypto.randomUUID() };
        const newRules = [...state.scoreRules, newRule];
        return {
            ...state,
            scoreRules: newRules,
            scoreErrors: validateScoreRules(newRules)
        };
    }

    if (action.type === 'CHANGE_COLOR') {
        const newRules = state.scoreRules.map(r => {
            if (action.id !== r.id) return r;
            return action.color_alert ? { ...r, color_alert: action.color_alert, } : { ...r };
        });
        return {
            ...state,
            scoreRules: newRules,
            scoreErrors: validateScoreRules(newRules)
        };
    }

    if (action.type === 'CHANGE_COMPARISON') {
        const newRules = state.scoreRules.map(r => {
            if (action.id !== r.id) return r;
            return action.comparison ? { ...r, comparison: action.comparison } : r;
        });
        return {
            ...state,
            scoreRules: newRules,
            scoreErrors: validateScoreRules(newRules)
        };
    }

    if (action.type === 'CHANGE_VALUE') {
        const newRules = state.scoreRules.map(r => {
            if (action.id !== r.id) return r;
            return { ...r, value: action.value };
        });
        return {
            ...state,
            scoreRules: newRules,
            scoreErrors: validateScoreRules(newRules)
        };
    }

    if (action.type === 'DELETE_RULE') {
        const newRules = state.scoreRules.filter(r => r.id !== action.id);
        return {
            ...state,
            scoreRules: newRules,
            scoreErrors: validateScoreRules(newRules),
            deletedIDs: typeof action.id === 'number' ? [...state.deletedIDs, action.id] : state.deletedIDs
        };
    }

    if (action.type === 'SET_ERROR_RULES') return { ...state, scoreErrors: action.scoreErrors };
    return state;
};

const DEFAULT_ALERT_RULE: Omit<IAlertRule, 'id'> = {
    enabled: true,
    inquiry_question_id: null,
    comparison: '>',
    value: 0,
    consecutive: 1,
    check_before: false,
    deleted: false
};

const updateAlert = (alerts: IAlertRule[], id: IAlertRule['id'], attributes: Partial<IAlertRule>) =>
    alerts.map(alert => (alert.id !== id) ? alert : { ...alert, ...attributes });

export const alertRulesReducer = (alerts: IAlertRule[], action: AlertRuleDispatch) => {

    if (action.type === 'ADD_RULE')
        return [...alerts, { ...DEFAULT_ALERT_RULE, id: crypto.randomUUID() }];

    if (action.type === 'CHANGE_ENABLED')
        return updateAlert(alerts, action.id, { enabled: action.enabled });

    if (action.type === 'CHANGE_QUESTION_ID')
        return updateAlert(alerts, action.id, { inquiry_question_id: action.inquiry_question_id }) ;

    if (action.type === 'CHANGE_VALUE')
        return updateAlert(alerts, action.id, { value: Number(action.value) });

    if (action.type === 'CHANGE_CONSECUTIVE')
        return updateAlert(alerts, action.id, { consecutive: action.consecutive });

    if (action.type === 'CHANGE_COMPARISON')
        return updateAlert(alerts, action.id, { comparison: action.comparison });

    if (action.type === 'CHANGE_CHECK_BEFORE')
        return updateAlert(alerts, action.id, { check_before: action.check_before });

    if (action.type === 'DELETE_RULE'){
        if(typeof action.id === 'string') return alerts.filter(a => a.id !== action.id);
        return updateAlert(alerts, action.id, { deleted: true });
    }


    return alerts;
};